export const getDebugEvents = (store) =>
  store && store.debugLogs && store.debugLogs.debugEvents;
